<div>
  <div class="md:flex md:items-center md:justify-between py-8">
    <div class="min-w-0 flex-1">
      <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
        Stock du magasin
      </h2>
    </div>
    <div class="mt-4 flex md:ml-4 md:mt-0">
      <button
        (click)="refreshStock()"
        type="button"
        class="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
      >
        Mettre à jour le stock
      </button>
    </div>
  </div>
</div>

<table mat-table [dataSource]="dataProductsList" multiTemplateDataRows>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Nom</th>
    <td mat-cell *matCellDef="let product">{{ product.name }}</td>
  </ng-container>

  <ng-container matColumnDef="categories">
    <th mat-header-cell *matHeaderCellDef>Catégories</th>
    <td mat-cell *matCellDef="let product">{{ product.categories }}</td>
  </ng-container>

  <ng-container matColumnDef="brand">
    <th mat-header-cell *matHeaderCellDef>Marque</th>
    <td mat-cell *matCellDef="let product">{{ product.brand }}</td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let product">
      <span
        (click)="addProductToVestra(product)"
        class="px-2 py-1 text-sm font-semibold text-gray-900 hover:bg-gray-50"
      >
        Ajouter le produit sur Vestra
      </span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr
    mat-row
    *matRowDef="let product; columns: displayedColumns"
    class="student-product-row"
    [class.product-expanded-row]="product.isExpanded"
  ></tr>
</table>
